import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { SecurityPolicies } from '../services/auth-variables';
import { AppDialogService } from '../services/app-dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SecurityPolicyGuard implements CanActivate {
    private readonly unauthorizedRouteMessageKey = 'Unauthorized.InsufficientRights';

    constructor(
      private authService: AuthService,
      public router: Router,
      private appDialogService: AppDialogService,
      private translate: TranslateService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        const securityPolicy: SecurityPolicies = route.data?.securityPolicy
        if (securityPolicy === undefined || securityPolicy === null)
          throw new Error('Security Policy not found in route data');

        // take(1) because getUserInformation() upstream returns a BehaviorSubject that never
        // completes; passesPolicyOf has its own internal take(1) today, but a guard should not
        // depend on that staying true.
        return this.authService.passesPolicyOf(securityPolicy).pipe(
          take(1),
          map((isAllowed) => {
            if (isAllowed) {
              return true;
            }

            this.appDialogService.showErrorMessage(
              this.translate.instant(this.unauthorizedRouteMessageKey),
            );
            return this.router.parseUrl('/dashboard');
          }),
        );
    }
}

